export default {
  getOpen() {
    return env.API.get('/user/announs');
  }
}
